var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.017,
    height: 21,
    viewBox: "0 0 20.017 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invite_icon_-_Team_members",
    "data-name": "Invite icon - Team members",
    transform: "translate(-5.79 -4.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34629",
    "data-name": "Path 34629",
    d: "M9.865,12.9a4.391,4.391,0,1,1,4.391,4.391A4.391,4.391,0,0,1,9.865,12.9Zm6.423,5.74H12.224a6.449,6.449,0,0,0-6.434,6.43.332.332,0,0,0,.335.335H22.386a.332.332,0,0,0,.335-.335,6.438,6.438,0,0,0-6.434-6.43ZM25.435,7.491H22.722V4.777a.335.335,0,1,0-.667,0V7.491H19.337a.335.335,0,0,0,0,.667h2.718v2.718a.335.335,0,0,0,.667,0V8.158h2.714a.335.335,0,1,0,0-.667Z",
    transform: "translate(0)",
    fill: "#989898"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteTeam);
export default __webpack_public_path__ + "static/media/inviteTeam.d3f5b3fb3d86c3c6370c9a76aed7dae2.svg";
export { ForwardRef as ReactComponent };